import { agreementDetailDTOSchema, agreementDTOSchema, agreementVersionDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const agreementListSchema = listEnvelopeSchema(agreementDTOSchema);
const agreementSchema = dataEnvelopeSchema(agreementDTOSchema);
const agreementDetailSchema = dataEnvelopeSchema(agreementDetailDTOSchema);
/** `POST /agreements/:id/versions` answers with the pair, not a bare `AgreementDTO`. Parsing it
 *  as one made every publish fail as an `INTERNAL_ERROR` response-schema mismatch. */
const publishedAgreementVersionSchema = dataEnvelopeSchema(z.object({ agreement: agreementDTOSchema, version: agreementVersionDTOSchema }));
/** `POST /agreements/source-pdf` answers a small `{ fileId }` envelope, not an `AgreementDTO`. */
const uploadedSourcePdfSchema = dataEnvelopeSchema(z.object({ fileId: z.string().min(1) }));
export function createAgreementsResource(transport) {
    return {
        async list(query) {
            return transport.request({
                path: `${WEB_API_PREFIX}/agreements`,
                schema: agreementListSchema,
                query: query === undefined
                    ? undefined
                    : { page: query.page, pageSize: query.pageSize, sort: query.sort, q: query.q },
            });
        },
        async get(id) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/agreements/${encodeURIComponent(id)}`,
                schema: agreementDetailSchema,
            });
            return envelope.data;
        },
        async create(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/agreements`,
                schema: agreementSchema,
                body: input,
            });
            return envelope.data;
        },
        async publishVersion(id, input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/agreements/${encodeURIComponent(id)}/versions`,
                schema: publishedAgreementVersionSchema,
                body: input,
            });
            return envelope.data.agreement;
        },
        async uploadSourcePdf(bytes, contentType) {
            const envelope = await transport.requestUpload({
                path: `${WEB_API_PREFIX}/agreements/source-pdf`,
                schema: uploadedSourcePdfSchema,
                contentType,
                // `.slice()`, not `bytes` directly: TS 5.7+ types `Uint8Array` as generic over its backing
                // buffer (`ArrayBufferLike`, which includes `SharedArrayBuffer`), and `BlobPart` only
                // accepts a concrete `ArrayBuffer`-backed view. `slice()` always allocates a fresh
                // standard `ArrayBuffer`, which satisfies `BlobPart` without an unsafe cast.
                body: new Blob([bytes.slice()], { type: contentType }),
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=agreements.js.map